import React, { useEffect, useState } from 'react';
import { MdClose } from 'react-icons/md';
import Modal from '../../components/modal';
import Button from '../../components/Button';
import { toast } from 'react-toastify';
import axios from 'axios';

const AssignTeachers = ({ isModalOpen, setIsModalOpen, closeModal, courseId, getData }) => {
  const [planData, setPlanData] = useState({
    name: '',
    courseId: courseId || '',
    timing: []
  });

  const [loading, setLoader] = useState(false);
  const [teachers, setTeachers] = useState([]);
  const [courses, setCourses] = useState([]);
  const [selectedTeacher, setSelectedTeacher] = useState(null);
  const [timeSlots, setTimeSlots] = useState([]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'name') {
      if (!value) {
        // If no teacher is selected, reset the state and return
        setSelectedTeacher(null);
        return;
      }

      const selectedTeacherData = teachers.find((teacher) => teacher._id === value);

      if (!selectedTeacherData) {
        console.error('Teacher not found');
        return;
      }

      setSelectedTeacher(selectedTeacherData);
      fetchTimeSlots(selectedTeacherData._id); // Only call if selectedTeacherData exists
    }

    setPlanData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleTimeSlotChange = (e) => {
    const { value } = e.target;
    if (!planData.timing.includes(value)) {
      setPlanData((prev) => ({
        ...prev,
        timing: [...prev.timing, value]
      }));
    }
  };

  const removeTimeSlot = (slot) => {
    setPlanData((prev) => ({
      ...prev,
      timing: prev.timing.filter((s) => s !== slot)
    }));
  };

  const fetchTimeSlots = async (teacherId) => {
    try {
      const response = await axios.get(
        `https://quran-backend-theta.vercel.app/v1/user/user-by-id/${teacherId}`
      );
      console.log(response);

      setTimeSlots(response?.data?.data?.timeSlots || []);
    } catch (error) {
      console.error(error);
    }
  };

  const bannerSubmit = (e) => {
    e.preventDefault();

    if (!isFormValid()) {
      toast.error('Please fill all fields');
      return;
    }
    setLoader(true); // Start loading

    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');

    const raw = JSON.stringify({
      courseId: planData?.courseId
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    fetch(
      `https://quran-backend-theta.vercel.app/v1/user/admission/${getData?._id}`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);
        // console.log("DATA", data);

        if (data?.success === true) {
          const myHeaders = new Headers();
          myHeaders.append('Content-Type', 'application/json');

          const raw = JSON.stringify({
            enrollmentId: data?.data?._id,
            teacherId: planData?.name,
            timing: planData?.timing
          });

          const requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
          };

          fetch('https://quran-backend-theta.vercel.app/v1/user/assign-teacher', requestOptions)
            .then((response) => response.text())
            .then((result) => {
              let data = JSON.parse(result);
              setLoader(false);
              // console.log("Assign DATA", data);
              if (data?.success === true) {
                toast.success('Admission confirmed!');
                setIsModalOpen(false);
                // window.location.reload();
              } else {
                toast.error(data?.error);
              }
            })
            .catch((error) => console.error(error));
        } else {
          setLoader(false);
          toast.error(data?.error);
        }
      })
      .catch((error) => console.error(error));
  };

  const isFormValid = () => {
    return planData.name !== '' && planData.courseId !== '' && planData.timing.length > 0;
  };

  useEffect(() => {
    const fetchTeachers = async () => {
      try {
        const response = await fetch('https://quran-backend-theta.vercel.app/v1/admin/all-teacher');
        const data = await response.json();
        setTeachers(data.data);
      } catch (error) {
        console.error(error);
      }
    };

    const fetchCourses = async () => {
      try {
        const response = await fetch('https://quran-backend-theta.vercel.app/v1/user/course');
        const data = await response.json();
        setCourses(data.courses);
      } catch (error) {
        console.error(error);
      }
    };

    fetchTeachers();
    fetchCourses();
  }, []);

  return (
    <div>
      <Modal isOpen={isModalOpen} onClose={closeModal} className={'rounded-md'}>
        <div>
          <div className="p-3 flex justify-between items-center">
            <h1 className="capitalize h4 font-medium">Add Details</h1>
            <MdClose onClick={() => setIsModalOpen(false)} size={25} />
          </div>
          <hr />
          <div className="p-5">
            <form onSubmit={bannerSubmit}>
              <div className="flex gap-5 flex-wrap">
                <div className="w-[48%]">
                  <label className="block mb-2 text-sm text-gray-900 font-medium">
                    Select Course
                  </label>
                  <select
                    name="courseId"
                    value={planData.courseId}
                    onChange={handleChange}
                    className="w-full py-3 outline-none bg-lightGray p-2.5 text-black placeholder:text-primary rounded-md"
                  >
                    <option value="">Select Course</option>
                    {courses?.map((course) => (
                      <option key={course._id} value={course._id}>
                        {course.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="w-[48%]">
                  <label className="block mb-2 text-sm text-gray-900 font-medium">
                    Assign Teacher
                  </label>
                  <select
                    name="name"
                    value={planData.name}
                    onChange={handleChange}
                    className="w-full py-3 outline-none bg-lightGray p-2.5 text-black placeholder:text-primary rounded-md"
                  >
                    <option value="">Select Teacher</option>
                    {teachers?.length > 0 &&
                      teachers.map((teacher) =>
                        teacher ? (
                          <option key={teacher._id} value={teacher._id}>
                            {teacher.name}
                          </option>
                        ) : null
                      )}
                  </select>
                </div>

                <div className="w-full">
                  <label className="block mb-2 text-sm text-gray-900 font-medium">Timing</label>
                  <select
                    name="timing"
                    onChange={handleTimeSlotChange}
                    className="w-full py-3 outline-none bg-lightGray p-2.5 text-black placeholder:text-primary rounded-md"
                  >
                    <option value="">Select Time Slot</option>
                    {timeSlots?.map((slot, index) => {
                      if (slot?.status === 'available') {
                        return (
                          <option key={index} value={`${slot.startTime} - ${slot.endTime}`}>
                            {slot.startTime} - {slot.endTime}
                          </option>
                        );
                      }
                    })}
                  </select>
                  <div className="mt-3">
                    <h4 className="text-sm font-medium mb-2">Selected Time Slots:</h4>
                    <div className="flex flex-wrap gap-2">
                      {planData.timing.map((slot, index) => (
                        <div
                          key={index}
                          className="flex items-center bg-gray-200 px-3 py-1 rounded"
                        >
                          <span>{slot}</span>
                          <button
                            type="button"
                            onClick={() => removeTimeSlot(slot)}
                            className="ml-2 text-red-500 hover:text-red-700"
                          >
                            ×
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              {loading ? (
                <button
                  disabled
                  type="button"
                  className="bg-[#FB5722] w-full text-center mt-3 py-2.5 rounded-lg text-white uppercase font-semibold cursor-not-allowed"
                >
                  <svg
                    aria-hidden="true"
                    role="status"
                    className="inline w-4 h-4 me-3 text-white animate-spin"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="#E5E7EB"
                    />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentColor"
                    />
                  </svg>
                  Loading...
                </button>
              ) : (
                <div className="flex justify-center pt-5">
                  <Button
                    label="Save"
                    type="submit"
                    className={`bg-secondary mt-3 text-white py-2.5 w-36 ${
                      !isFormValid() ? 'cursor-not-allowed opacity-50' : ''
                    }`}
                    disabled={!isFormValid()}
                  />
                </div>
              )}
            </form>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default AssignTeachers;
